import '../App.css';
import foto01 from '../images/foto01.jpg';
import Rodape from "./Rodape";
import RobotImage from '../images/conversando.png';
import { useEffect, useState } from "react";

const Franqueado = () => {
    const [chatUnavailable, setChatUnavailable] = useState(false); // Estado para controlar o aviso

    const openChat = () => {
        // Verificação para abrir o chat ou exibir a pop-up
        if (typeof window.jivo_api !== 'undefined' && typeof window.jivo_api.open === 'function') {
            window.jivo_api.open(); // Se o chat estiver disponível, abre o chat
        } else {
            setChatUnavailable(true); // Se o chat não estiver disponível, mostra a pop-up
        }
    };

    useEffect(() => {
        const interval = setInterval(() => {
            if (typeof window.jivo_api !== 'undefined') {
                clearInterval(interval); // Interrompe o intervalo quando o jivo_api estiver disponível
            }
        }, 500);

        return () => clearInterval(interval); // Limpa o intervalo quando o componente for desmontado
    }, []);

    const closePopup = () => {
        setChatUnavailable(false); // Fecha o aviso de chat indisponível
    };

    return (
        <div className="pt-24 md:pt-0">
            <div className='relative h-[300px] md:h-80 flex flex-col md:flex-row font-navBarFont bg-[#17A541]'>
                <div className='flex flex-col justify-center p-4 md:p-8 w-full md:w-[58%] text-white bg-[#17A541] mt-12 bg'>
                    <div className='text-left md:pl-16'>
                        <h3 className='text-xl md:text-2xl mb-4'>
                            Seja um parceiro
                        </h3>
                        <h1 className='text-xl md:text-4xl font-bold mb-4'>
                            Protege Piso
                        </h1>
                        <h2 className='text-lg md:text-xl'>
                            Trabalhe com o melhor sistema de proteção de pisos para sua obra.
                        </h2>
                    </div>
                </div>

                <div className='relative w-full md:w-[42%] bg-cover bg-center mt-12'
                     style={{ backgroundImage: `url(${foto01})` }}>
                    <img
                        src='https://protegepiso.com.br/wp-content/uploads/elementor/thumbs/logo-contorno-final-3-qr9ktubyh3wykeoagoppheagkansuuyyyeqvz95qtk.png'
                        alt='Logo'
                        className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 md:w-1/3'
                    />
                </div>
            </div>
            <div className='bg-[#126232] text-white p-4 md:p-8 flex flex-col md:flex-row'>
                <div className='w-full md:w-3/4 font-light font-navBarFont'>
                    <h3 className='text-lg md:text-xl mb-2 '>
                        • Sistema de proteção aprovado para qualquer tipo de piso (área interna, externa e pisos de madeira), sem a utilização de adesivos.
                    </h3>
                    <h3 className='text-lg md:text-xl mb-2'>
                        • Tecnologia exclusiva para suportar grandes impactos.
                    </h3>
                    <h3 className='text-lg md:text-xl mb-2'>
                        • Redução de ruídos na obra.
                    </h3>
                    <h3 className='text-lg md:text-xl mb-2'>
                        • Impecável performance em vedação para líquidos e sólidos.
                    </h3>
                    <h3 className='text-lg md:text-xl mb-2'>
                        • Geometria antiderrapante das placas.
                    </h3>
                    <h3 className='text-lg md:text-xl'>
                        • Produto sustentável, 100% reciclado e reutilizável.
                    </h3>
                </div>
                <div className='w-full md:w-1/4 flex flex-col items-center mt-4 md:mt-0'>
                    <img src='https://protegepiso.com.br/wp-content/uploads/2020/05/pasted-svg-245276x99-1.png' alt='Imagem 1' className='w-1/2 mb-5' />
                    <img src='https://protegepiso.com.br/wp-content/uploads/2020/05/selobrasil.png' alt='Imagem 2' className='w-1/2' />
                </div>
            </div>

            <div className='p-4 md:px-48 mt-12 mb-12 font-navBarFont'>
                <h1 className='text-xl md:text-3xl font-extrabold text-[#126232] text-center mb-12'>
                    Descubra as vantagens e benefícios de ser um franqueado Protege Piso na sua região.
                </h1>
                <div className='flex flex-col md:flex-row justify-center'>
                    <ul className='w-full md:w-1/2 space-y-4 text-left pl-6 list-disc'>
                        <li className='text-base md:text-lg'>
                            Treinamento e capacitação completa de toda a equipe.
                        </li>
                        <li className='text-base md:text-lg'>
                            Software com sistema de operação e gerenciamento de obras.
                        </li>
                        <li className='text-base md:text-lg'>
                            Assessoria de marketing e propaganda padronizada para sites, mídias sociais e artes gráficas.
                        </li>
                        <li className='text-base md:text-lg'>
                            Garantia ilimitada do produto.
                        </li>
                    </ul>

                    <ul className='w-full md:w-1/2 space-y-4 text-left pl-6 list-disc'>
                        <li className='text-base md:text-lg'>
                            Produto pioneiro e patenteado.
                        </li>
                        <li className='text-base md:text-lg'>
                            Participação em feiras e eventos.
                        </li>
                        <li className='text-base md:text-lg'>
                            Baixo custo operacional e alta rentabilidade.
                        </li>
                        <li className='text-base md:text-lg'>
                            Área regional de atuação.
                        </li>
                    </ul>
                </div>
            </div>

            <div className="w-full bg-[#D0CFCF] pb-28 flex flex-col items-center justify-center text-center">
                <h2 className="text-xl md:text-2xl lg:text-3xl font-bold mb-6 text-[#126232]">
                    Entre em contato conosco através do nosso Chat.
                </h2>

                <button
                    id="openChatBtn"
                    className="bg-[#1068c7] text-white font-semibold py-3 px-10 rounded-full shadow-md hover:bg-[#3e99fa] transition-all duration-300 mb-4 flex items-center justify-center"
                    onClick={openChat}
                >
                    Abrir Chat
                    <img src={RobotImage} alt="Robô" className="w-8 h-8 ml-2" />
                </button>
            </div>

            {chatUnavailable && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg text-center">
                        <h2 className="text-xl font-bold mb-4">Chat Indisponível</h2>
                        <p>O chat não está disponível no momento. Tente novamente mais tarde.</p>
                        <button
                            className="mt-4 bg-[#1068c7] text-white py-2 px-4 rounded-full"
                            onClick={closePopup}
                        >
                            Fechar
                        </button>
                    </div>
                </div>
            )}

            <Rodape />
        </div>
    );
};

export default Franqueado;
